import React, { useEffect, useState } from "react";
import { VsiBubble, VsiH4 } from "../../../styled/App.styled";
import { useDataWithRoute, useTitleFromComponent } from "../../../utils/hooks";
import Grid from "../../../components/Grid";
import SunburstChart from "../../../components/SunburstChart";
import Highcharts from "highcharts/highstock";
import { Card, Spinner } from "reactstrap";
import { useVsiAppContext } from "../../../stores/VsiApp";
import { databaseVersionDefs } from "../../../utils/gridColumnDefs/databases/databaseVersionDefs";


export default function DatabaseVersions({title}) {
    useTitleFromComponent(title);

    const { theme, client, periodId } = useVsiAppContext();
    const [data, {isLoading}] = useDataWithRoute(`/api/v6/report/database_version_proc?client_id=${client.clientId}&period_id=${periodId}`);
    const [chartData, setChartData] = useState([]);

    const colors = {
        "Microsoft SQL Server Database": "#fEb800",
        "Oracle Database": "#c74634",
        "IBM DB2 Database": "#0f62fe",
    };

    const gradient = (color, index) =>
        // Start out with a darkened base color (negative brighten), and end
        // up with a much brighter color
        Highcharts.color(color)
            .brighten((index - 9) / 34)
            .get()

    useEffect( () => {
        const records = data?.recordset;
        let nodes = [];
        let vendors = {};
        if (!isLoading) {
            records.forEach((record) => {
                let version = record?.version_full;
                let name = record?.device_type_description;
                if (!vendors.hasOwnProperty(name)) {
                    vendors[name] = {versions: [version], value: 1};
                } else {
                    vendors[name].versions.push(version);
                    vendors[name].value += 1;
                }
            });
        }

        Object.keys(vendors).forEach((vendor, index) => {
            let color = colors[vendor];
            nodes.push(
                {
                    name: vendor.split("_")[0],
                    id: vendor,
                    value: vendors[vendor].value,
                    color: gradient(color, index),
                }
            );
            let versions = vendors[vendor].versions;
            if (versions.length > 0) {
                for (let i = 0; i < versions.length; i ++) {
                    let major = versions[i].split(".")[0].replace(/[a-zA-Z]/g, "") || 'No version available';
                    let versionNode = 
                            {
                                name: versions[i] || 'No specified version available',
                                parent: `${vendor}-${major}`,
                                value: 1,
                                color: gradient(color, index + i),
                            };
                    let verNode = nodes.find((node) => node.name === versionNode.name);
                    if (verNode) {
                        verNode.value += 1;
                    } else {
                        nodes.push(versionNode);
                    }
                };
                let majors = [...new Set(versions.map((ver) => {
                    return Number(ver.split(".")[0].replace(/[a-zA-Z]/g, ""));
                }))].sort((a, b) => b - a);
                for (let i = 0; i < majors.length; i++) {
                    const major = majors[i] || 'No version available';
                    nodes.push(
                        {
                            name: major,
                            id: `${vendor}-${major}`,
                            parent: vendor,
                            color: gradient(color, index + i),
                        }
                    );
                };
            }
        });
        setChartData(nodes);
    }, [data, isLoading]);

    return (
        <Card className={`report-card p-2 nav-card-${theme}`}>
            <VsiH4>Databases Versions</VsiH4>
            {isLoading ? <Spinner color={"primary"}/> : (
                chartData.length > 0 ? (
                <VsiBubble noAutobot>
                    <SunburstChart
                        data={chartData ?? []}
                        height={"50%"}
                        disableLegend
                    />
                </VsiBubble>
                ) : null
            )}
            <VsiBubble>
                <Grid addStyle
                        data={data?.recordset ?? []}
                        isLoading={isLoading}
                        columnDefs={databaseVersionDefs}/>
            </VsiBubble>
        </Card>
    );
}
